// @tennis-matches/services/governance — Öffentliche Impressum-Felder für Vereinsprofile
//
// Bewusst NUR organisatorische Stammdaten (Verein als juristische/organisatorische Einheit).
// Keine personenbezogenen Beziehungsdaten (z. B. Vorstandsnamen → club_people / separates Modell).

/** @type {readonly string[]} */
export const CLUB_IMPRINT_PROFILE_KEYS = [
  "city",
  "postal_code",
  "street",
  "house_number",
  "country",
  "website_url",
  "email",
  "phone",
  "club_short_name",
  "legal_name",
  "register_court",
  "register_number",
  "dtb_club_id",
  "btv_club_id",
  "founded_year",
  "discover_source_ags",
];

/** Feldnamen für Superadmin-Formulare (data-field). */
export const CLUB_ADD_FORM_FIELDS = [
  "club_name",
  ...CLUB_IMPRINT_PROFILE_KEYS,
];
